const getters = {
  sidebar: (state) => state.app.sidebar,
  device: (state) => state.app.device,
  drawer: (state) => state.app.drawer,
  token: (state) => state.user.token,
  avatar: (state) => state.user.avatar,
  name: (state) => state.user.name,
  user: (state) => state.user.user,
  roles: (state) => state.user.roles,
  permission_routers: (state) => state.permission.routers,
  addRouters: (state) => state.permission.addRouters,
  uploads: (state) => state.uploads.state,
  getPlanet: (state) => {
    return state.planet.planet;
  },
  getMember: (state) => {
    return state.planet.member;
  },
  getUpdateMethod: (state) => {
    return state.planet.updateMethod;
  },
};

export default getters;
